import React, { Component } from "react";
import { Button, Card, Col, Input, Row } from "antd";
import DefaultLayout from "../../../../layouts/DefaultLayout";
import { inject } from "mobx-react";

@inject("context")
class CustomerLogin extends Component {
	state = {
		email: "",
	};

	render() {
		return (
			<DefaultLayout
				layoutContentProps={{
					style: {
						maxWidth: "100%",
						paddingLeft: 20,
						paddingRight: 20,
					},
				}}
			>
				<Row>
					<Col xs={24} className="portal-card">
						<Card title={<h1>Customer Portal Login</h1>}>
							<Row>
								<Col xs={17} style={{}}>
									<p>
										Please enter your email to get a link for the new login
										session
									</p>
									<Input
										value={this.state.email}
										onChange={this.handleChange.bind(this)}
									/>
								</Col>
								<Col xs={7} className="portal-login-button">
									<Button
										type="primary"
										onClick={this.handleSendButton.bind(this)}
									>
										Send
									</Button>
								</Col>
							</Row>
						</Card>
					</Col>
				</Row>
			</DefaultLayout>
		);
	}

	handleChange(e) {
		this.setState({ email: e.target.value });
	}

	handleSendButton() {
		const { customerPortalService } = this.props.context;
		customerPortalService.sendPortalAccessLink(this.state.email);
	}
}

export default CustomerLogin;
